<template>
    <router-view :maximized="maximized"></router-view>
</template>

<script>
export default {
  name: "VisualRecognition",
  
};
</script>

